const GradientOrbs = () => (
  <>
    <style>{`
      @keyframes orb1 { 0%,100% { transform: translate(0,0); } 33% { transform: translate(40px,-30px); } 66% { transform: translate(-20px,20px); } }
      @keyframes orb2 { 0%,100% { transform: translate(0,0); } 33% { transform: translate(-30px,25px); } 66% { transform: translate(15px,-15px); } }
      @keyframes orb3 { 0%,100% { transform: translate(0,0); } 33% { transform: translate(20px,-20px); } 66% { transform: translate(-25px,10px); } }
    `}</style>
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
      <div
        className="absolute -top-32 -left-32 w-[500px] h-[500px] rounded-full opacity-[0.07]"
        style={{
          background: "radial-gradient(circle, hsl(var(--ochre)) 0%, transparent 70%)",
          filter: "blur(80px)",
          animation: "orb1 20s ease-in-out infinite",
        }}
      />
      <div
        className="absolute top-1/4 -right-20 w-[400px] h-[400px] rounded-full opacity-[0.06]"
        style={{
          background: "radial-gradient(circle, hsl(var(--violet)) 0%, transparent 70%)",
          filter: "blur(80px)",
          animation: "orb2 25s ease-in-out infinite",
        }}
      />
      <div
        className="absolute bottom-10 left-1/3 w-[350px] h-[350px] rounded-full opacity-[0.05] hidden md:block"
        style={{
          background: "radial-gradient(circle, hsl(var(--warmglow)) 0%, transparent 70%)",
          filter: "blur(80px)",
          animation: "orb3 18s ease-in-out infinite",
        }}
      />
    </div>
  </>
);

export default GradientOrbs;
